module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":"Copy the following content, and paste it on your website."},"id":{"text":"Salin konten berikut, dan tempel di situs web kamu"}}')
  delete Component.options._Ctor
}
